<template>
<div v-if="editorsPick && editorsPick._id" class='h-100'>
    <div class="card border-0 rounded-bottom-10 rounded-top-10 h-100 " :style="{
        'background': 'linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.00) 28.87%), ' +
        'linear-gradient(0deg, rgba(0, 0, 0, 0.25) -0.11%, rgba(0, 0, 0, 0.00) 35.2%), ' +
         bgColor  + ''
        }">
        <div class="d-flex editor-pick-add-toa-collection justify-content-between">
            <div class="align-items-center badge d-flex poc-badge">
                <p class="sm--text-poc m-0 ml-1 p-0" v-if="poclabel">{{poclabel}}
                </p>
                <img v-if="isReadContent" class="mx-1 " src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/read-Vector.svg" alt="">
                <img v-if="!isReadContent" class="mx-1" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/play-Vector.svg" alt="">
            </div>
        </div>
        <a class="position-relative pick-poc-card-img vue-ep" :href="[pocLink]" v-if="cardImage">
            <img class="rounded-top-10 w-100" :alt="editorsPick.title" v-if="cardImage" :src="cardImage" />
            <h4 v-if="editorsPick && editorsPick.title" class="sands--hide">
                    {{editorsPick.title}}
                </h4>
            <p v-if="editorsPick.parentName && ((editorsPick.parentGenre && editorsPick.parentGenre != 'FSLE') || !editorsPick.parentGenre)" class="m-0 parent__name text-white position-absolute">{{cuteventName(editorsPick.parentName)}}</p>
        </a>
        <div class="card-body d-flex flex-column justify-content-between pick-poc-card-body px-3 py-3 text-white">
            <!-- parent logo and Name  and poc type-->
            <a class="text-white" :href="[pocLink]">
                <h4 v-if="editorsPick && editorsPick.title" class="font-weight-bold h5">
                    {{editorsPick.title}}
                </h4>
            </a>
            <div class="author-date-wrapper">
                <div v-if="isReadContent && durationInMinutes" class="poc-small-text">
                    {{durationInMinutes}} 
                    <span>{{ $t('BrandComplex.minRead') }}</span>
                </div>
                <!-- <div class="poc-small-text" v-if="!isReadContent && displayDateTime">{{displayDateTime}}</div> -->
            </div>
        </div>
    </div>

</div>
</template>

<script>
import moment from 'moment';
import helperfunctions from "../../services/helperfunctions.js";

export default {
    name: "singlePocEditors",
    created() {
        this.cardImage = this.setCardImage();
    },
    data() {
        return {
            isReadContent: false,
            displayImage: false,
            poclabel: String,
            slug: '',
            displayDateTime: null,
            bgColor: '#007d8d',
            language: 'DE',
            pocRgba: {
                r: 20,
                g: 147,
                b: 92,
                a: 1
            },
            cardImage: '',
            durationInMinutes: this.editorsPick.duration ? Math.floor(this.editorsPick.duration / 60) : '',
            pocLink: this.realUrl ? this.realUrl.replace(/\s+/g, '-') : '#',
        };
    },
    props: {
        editorsPick: Object,
        realUrl: String,
        settingsPerm: Object,
        isDevMioActive: Boolean,
        isDevmioNlActive: Boolean
    },
    mounted() {
        this.formatDates();
        this.getLanguage();
        this.getCorrectPocType();
        if (this.editorsPick.parentColorHexCode) {
            this.bgColor = this.editorsPick.parentColorHexCode;
        } else if (this.settingsPerm && this.settingsPerm.isDevMioActive || this.settingsPerm.isDevmioNlActive) {
            this.bgColor = "#34046E"
        }
    },
    methods: {
        formatDates() {
            if (this.editorsPick && this.editorsPick.isReadContent) {
                this.isReadContent = true;
            } else {
                if (!this.isReadContent && this.editorsPick.startDate && this.editorsPick.endDate &&
                    moment(this.editorsPick.startDate, 'DD-MM-YYYY HH:mm:ss').isValid() && moment(this.editorsPick.endDate, 'DD-MM-YYYY HH:mm:ss').isValid()) {
                    this.displayDateTime = moment(this.editorsPick.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LL') + ' | ' + moment(this.editorsPick.startDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT') + ' - ' + moment(this.editorsPick.endDate, 'DD-MM-YYYY HH:mm:ss', 'DE').format('LT');
                }
            }
        },

        setCardImage() {
            if (this.editorsPick && this.editorsPick.parentGenre && (this.editorsPick.parentGenre == "RHEINGOLD" || this.editorsPick.parentGenre == "FLEX_CAMP" || this.editorsPick.parentGenre == "CAMP") && this.editorsPick.parentLogo) {
                return this.editorsPick.parentLogo;
            }
            return this.editorsPick.teaserImage ? this.editorsPick.teaserImage : '';
        },

        getCorrectPocType() {
            if (this.editorsPick && this.editorsPick.parentSchemaType && this.editorsPick.schemaType) {
                if (this.editorsPick.isReadContent) {
                    this.poclabel = 'Artikel';
                    this.pocType = 'Artikel';
                    if (this.language === 'EN') {
                        this.poclabel = 'Article';
                    } else if (this.language === 'NL') {
                        this.poclabel = 'Artikel';
                    }
                } else {
                    this.poclabel = helperfunctions.getCorrectPocType(this.editorsPick.parentGenre, this.editorsPick.parentSchemaType, this.editorsPick.schemaType);
                }
            }
        },

        cuteventName(eventName) {
            if (eventName && eventName.length > 38) {
                eventName = eventName.slice(0, 38) + "...";
            }
            return eventName;
        },

        getLanguage() {
            if (this.settingsPerm.isDevMioActive || this.settingsPerm.isDevmioNlActive) {
                this.language = 'EN';
            } else {
                this.language = 'DE';
            }
        }
    },
};
</script>

<style lang="css" scoped>
.editor-pick-wrapper {
    min-height: 256px;
    flex-shrink: 0;
    position: relative;
}

.parent__name {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    bottom: 8px;
    left: 12px;
}

/* .vue-ep img {
    min-height: 175px;
    max-height: 175px;
} */

.poc-small-text {
    font-family: sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.poc-badge {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    min-width: 55px;
    width: fit-content;
    color: white;
    max-height: 20px;
    padding: 13px 7px;
    background:rgb(0 85 108 / 80%)
}

.sm--text-poc {
    padding-bottom: 2px;
}

.e-pick-badge-image-wrapper .bg-image-wrapper {
    height: 24px;
    width: 24px;
}

.e-pick-badge-image-wrapper p {
    color: #fff;
    font-family: "Open Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.editor-pick-teaser-i-opacity {
    opacity: 0.45;
    mix-blend-mode: luminosity;
}

.editor-pick-teaser-i-wrapper {
    position: absolute;
    margin: auto;
    right: 0;
    left: 0;
    top: 0;
    height: 100%;
    z-index: -1;
}

.editor-pick-add-toa-collection .poc-badge {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 9;
}

.editor-pick-add-toa-collection .ep__poc__collection {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 9;
}
</style>
